import yup from '@/libs/yup';

export default yup.object({
    idn: yup.string().required('Name is a required field').idn(),
    description: yup.string().trim(),
    connector_idn: yup.string().required('Connector is a required field'),
    url: yup.string().required('URL is a required field').url(),
    command_idns: yup
        .array()
        .of(
            yup
                .string()
                .idn(
                    'Command Idn must start with a letter or underscore, and can only contain letters, numbers or underscores.'
                )
        )
});
